import React, { useState } from 'react'
import { Box, Tooltip, IconButton, TableCell, TableRow } from '@mui/material'
import Delete from './Delete'
import Form from './Form'
import { usePatchLuckyDraw } from '../../api/lucky-draw'
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined'
import EditOutlinedIcon from '@mui/icons-material/EditOutlined'

const Row = ({ data, refetch }) => {
  const [editing, setEditing] = useState(false)
  const [openDelete, setOpenDelete] = useState(false)

  return (
    <>
      <TableRow style={{ borderBottom: 'unset' }}>
        <TableCell>{data.companyAccountId}</TableCell>
        <TableCell>{data.companyName}</TableCell>
        <TableCell>{data.promotion1}</TableCell>
        <TableCell>{data.promotion2}</TableCell>
        <TableCell>-{data.ticketDeducted}</TableCell>
        <TableCell align='right'>
          <Box display='flex' justifyContent='space-evenly'>
            <Tooltip title='Edit Lucky Draw'>
              <IconButton onClick={() => setEditing(true)}>
                <EditOutlinedIcon fontSize='small' />
              </IconButton>
            </Tooltip>
            <Tooltip title='Delete Lucky Draw'>
              <IconButton onClick={() => setOpenDelete(true)}>
                <DeleteOutlinedIcon fontSize='small' />
              </IconButton>
            </Tooltip>
          </Box>
        </TableCell>
      </TableRow>
      <Delete
        data={data}
        onClose={() => setOpenDelete(false)}
        openDelete={openDelete}
        refetch={refetch}
      />
      <Form
        defaultValues={data}
        open={editing}
        setOpen={setEditing}
        api={usePatchLuckyDraw}
        refetch={refetch}
      />
    </>
  )
}

export default Row
